import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { getPagedProducts } from '../../services/productService';
import { ProductSortType } from '../../types';
import { formatPrice } from '../../lib/utils';
import 'swiper/css';
import 'swiper/css/navigation';

const PLACEHOLDER_IMAGE = 'https://placehold.co/370x250?text=No+Image';

const decodeHtml = (html) => {
  if (!html) return '';
  if (typeof document === 'undefined') return html;
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

function Special() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [prevEl, setPrevEl] = useState(null);
  const [nextEl, setNextEl] = useState(null);

  const options = {
    slidesPerView: 4,
    spaceBetween: 45,
    loop: true,
    navigation: {
      prevEl,
      nextEl,
    },
    autoplay: {
      delay: 7000,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      600: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  };

  useEffect(() => {
    const fetchSpecialProducts = async () => {
      try {
        const response = await getPagedProducts({
          page_size: 6,
          sort_type: ProductSortType.PriceHigh,
          only_active: true
        });
        if (response && response.items) {
          setProducts(response.items);
        }
      } catch (error) {
        console.error("Error fetching special products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSpecialProducts();
  }, []);

  return (
    <>
      <section className="special-offer">
        <div className="outer-container">
          <div className="auto-container">
            <div className="title-box centered">
              <div className="subtitle">
                <span>specijalna ponuda</span>
              </div>
              <div className="pattern-image">
                <img src={require('../../assets/images/icons/separator.svg').default} alt="mySvgImage" />
              </div>
              <h2>Najbolji specijaliteti</h2>

            </div>
            <Swiper
              className="dish-gallery-slider"
              modules={[Navigation]}
              {...options}
            >
              {loading ? (
                <SwiperSlide>
                  <div className="inner-box" style={{ textAlign: 'center', padding: '20px' }}>
                    Učitavanje...
                  </div>
                </SwiperSlide>
              ) : (
                products.map((product, index) => (
                  <SwiperSlide key={product.id} className={`offer-block-two ${index % 2 !== 0 ? 'margin-top' : ''}`}>
                    <div className="inner-box">
                      <div className="image">
                        <Link to="#">
                          <img 
                            src={product.image_urls && product.image_urls.length > 0 ? product.image_urls[0] : PLACEHOLDER_IMAGE} 
                            alt={product.name}
                            style={{ width: '100%', height: '250px', objectFit: 'cover' }} 
                          />
                        </Link>
                      </div>
                      <h4>
                        <Link to="#">{product.name}</Link>
                      </h4>
                      <div className="text desc">
                        {product.description 
                          ? decodeHtml(product.description).replace(/<[^>]*>?/gm, '').substring(0, 80) + (product.description.length > 80 ? '...' : '') 
                          : 'Opis uskoro...'}
                      </div>
                      <div className="price">
                        {product.retail_price 
                          ? formatPrice(product.retail_price.amount, product.retail_price.currency_code || 'RSD') 
                          : ''}
                      </div>
                    </div>
                  </SwiperSlide>
                ))
              )}
            </Swiper>
            <div className="swiper-button-prev-c" ref={(node) => setPrevEl(node)}>
              <span className="fal fa-angle-left"></span>
            </div>
            <div className="swiper-button-next-c" ref={(node) => setNextEl(node)}>
              <span className="fal fa-angle-right"></span>
            </div>
            
            <div className="lower-link-box text-center">
              <Link to="/menu" className="theme-btn btn-style-two clearfix">
                <span className="btn-wrap">
                  <span className="text-one">pogledajte ceo meni</span>
                  <span className="text-two">pogledajte ceo meni</span>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </section >
    </>
  );
}

export default Special;
